/**
 * The pipeline's rungs in climbing order. A rung the investigator names differently
 * renders nothing, so this is the one place to correct if its vocabulary moves.
 */
export const RUNG_LABELS: ReadonlyArray<{ key: string; label: string }> = [
  { key: 'comprehension', label: 'Comprehension' },
  { key: 'knowledge_availability', label: 'Knowledge availability' },
  { key: 'retrieval_execution', label: 'Retrieval execution' },
  { key: 'instruction', label: 'Instruction' },
  { key: 'reasoning', label: 'Reasoning' },
  { key: 'authority', label: 'Authority' },
  { key: 'delivery', label: 'Delivery' },
];
